import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Statistic, Typography } from 'antd';
import { FileTextOutlined, TeamOutlined, CheckCircleOutlined, ClockCircleOutlined } from '@ant-design/icons';
import MainLayout from '../components/Layout/MainLayout';
import { useAuthStore } from '../store/authStore';
import api from '../services/api';

const { Title } = Typography;

const Main: React.FC = () => {
  const { user } = useAuthStore();
  const [stats, setStats] = useState({
    totalDraft: 0,
    pending: 0,
    approved: 0,
    alba: 0
  });

  // 통계 조회
  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await api.get('/api/dashboard/stats');
        if (response.data.resultCode === 200) {
          setStats(response.data.data);
        }
      } catch (error) {
        console.error('통계 조회 오류:', error);
      }
    };

    fetchStats();
  }, []);

  return (
    <MainLayout>
      {/* 환영 메시지 */}
      <Card style={{ marginBottom: 24 }}>
        <Title level={3}>안녕하세요, {user?.Admin_Name}님! 👋</Title>
        <p style={{ color: '#666' }}>오늘도 좋은 하루 되세요.</p>
      </Card>

      {/* 통계 카드 */}
      <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="전체 기안서"
              value={stats.totalDraft}
              prefix={<FileTextOutlined />}
              valueStyle={{ color: '#3f8600' }}
              suffix="건"
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="대기 중"
              value={stats.pending}
              prefix={<ClockCircleOutlined />}
              valueStyle={{ color: '#faad14' }}
              suffix="건"
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="승인 완료"
              value={stats.approved}
              prefix={<CheckCircleOutlined />}
              valueStyle={{ color: '#1890ff' }}
              suffix="건"
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="일용직 인원"
              value={stats.alba}
              prefix={<TeamOutlined />}
              valueStyle={{ color: '#722ed1' }}
              suffix="명"
            />
          </Card>
        </Col>
      </Row>

      {/* 마이그레이션 진행 상황 */}
      <Card title="🚀 React 마이그레이션 진행 상황">
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Card type="inner" title="✅ 완료된 작업 (Phase 0-3)">
              <ul style={{ paddingLeft: 20, lineHeight: '1.8' }}>
                <li><strong>Phase 0: 환경 구축</strong>
                  <ul style={{ paddingLeft: 20 }}>
                    <li>CRA + TypeScript + React 19</li>
                    <li>Ant Design + 나눔스퀘어 폰트</li>
                    <li>CORS, 세션, 인증</li>
                  </ul>
                </li>
                <li><strong>Phase 1: 레이아웃</strong>
                  <ul style={{ paddingLeft: 20 }}>
                    <li>상단바 네비게이션</li>
                    <li>Modern Material Design</li>
                  </ul>
                </li>
                <li><strong>Phase 2: 기안서 모듈 (100%)</strong>
                  <ul style={{ paddingLeft: 20 }}>
                    <li>CRUD, 검색, 승인/비용처리</li>
                    <li>임시저장, 수정 이력</li>
                    <li>스마트에디터2, 파일 업로드</li>
                  </ul>
                </li>
                <li><strong>Phase 3: 일용직 모듈 (100%)</strong>
                  <ul style={{ paddingLeft: 20 }}>
                    <li>일용직 등록, 목록 관리</li>
                    <li>인력풀 관리 (등록, 검색, 삭제)</li>
                    <li>검색 (기간, 업무명, 성명)</li>
                    <li>Excel 업로드/다운로드</li>
                    <li>파일 생성, 통계 생성</li>
                    <li>주민번호/전화번호 실시간 검증</li>
                  </ul>
                </li>
              </ul>
            </Card>
          </Col>
          <Col span={12}>
            <Card type="inner" title="🚀 배포 완료 (검증 대기)">
              <ul style={{ paddingLeft: 20, lineHeight: '1.8' }}>
                <li><strong>배포 완료</strong>
                  <ul style={{ paddingLeft: 20 }}>
                    <li>프로덕션 빌드 완료</li>
                    <li>EJS 시스템 제거</li>
                    <li>포트: 7007</li>
                    <li>도메인: acgerp.insahr.co.kr</li>
                    <li>PM2 운영 중</li>
                  </ul>
                </li>
                <li><strong>테스터 검증 항목</strong>
                  <ul style={{ paddingLeft: 20 }}>
                    <li>기안서 CRUD, 검색, 승인/비용처리</li>
                    <li>일용직 등록, 인력풀, 검색</li>
                    <li>Excel 업로드/다운로드</li>
                    <li>파일 생성, 통계</li>
                    <li>관리자 관리</li>
                    <li>권한별 기능</li>
                  </ul>
                </li>
              </ul>
            </Card>
          </Col>
        </Row>
      </Card>
    </MainLayout>
  );
};

export default Main;
